/* eslint-disable react/forbid-component-props */
import { SxProps } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Zoom } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import 'swiper/css';
import 'swiper/css/zoom';
import React, { FC } from 'react';
import { combineSX } from '@/utils/combineSX';
import { Img } from '@/components/blocks/MaterialImage';
import { keepOriginalSizeOnZoomOut } from '@/utils/swiperZoom';
import {
	productDetailsSingleCarouselImageSX,
	productDetailsSingleCarouselSX,
} from '@/components/blocks/ProductDetails/styles/singleCarousel';

export const modifyVideoPlaceholderSrc = (src: string) => {
	if (src.includes('.mp4')) {
		return src.replace('.mp4', '.jpg');
	}
	return src;
};

export type SingleCarouselProps = {
	slides: { alt: string; src: string }[];
	slidesToShow: number;
	imageFrameSX?: SxProps;
	videoSX?: SxProps;
	onSwiper?: (swiper: SwiperType) => void;
	onSlideChange?: (index: number) => void;
	initialSlide?: number;
};

export const ProductDetailsSingleCarousel: FC<SingleCarouselProps> = ({
	slides,
	slidesToShow,
	imageFrameSX,
	videoSX,
	onSwiper,
	onSlideChange,
	initialSlide = 0,
}) => (
	<Box sx={productDetailsSingleCarouselSX}>
		<Swiper
			modules={[Zoom]}
			zoom={{ maxRatio: 3 }}
			slidesPerView={slidesToShow}
			slidesPerGroup={1}
			spaceBetween={0}
			initialSlide={initialSlide}
			onSwiper={onSwiper}
			onSlideChange={(swiper: SwiperType) => onSlideChange?.(swiper.activeIndex)}
			onInit={keepOriginalSizeOnZoomOut}
		>
			{slides.map(({ src, alt }, i) => (
				<SwiperSlide key={i}>
					<Box sx={imageFrameSX} position="relative">
						{src.includes('.mp4') ? (
							<Box
								component="video"
								src={src}
								controls
								sx={combineSX([
									{
										width: '100% !important',
										height: '100% !important',
									},
									...(Array.isArray(videoSX) ? videoSX : [videoSX]),
								])}
							/>
						) : (
							<Box className="swiper-zoom-container">
								<Img
									src={src}
									alt={alt}
									draggable={false}
									sx={productDetailsSingleCarouselImageSX}
								/>
							</Box>
						)}
					</Box>
				</SwiperSlide>
			))}
		</Swiper>
	</Box>
);
